/* eslint-disable max-len */
/* tslint:disable */
// TOTVS TypeScript translation resource
// Reference date : 20240118

export const generalEs = {
  str0001: 'Portal de Ventas (Línea Protheus)',
  str0002: 'Cargar más resultados',
  str0003: 'Mis Notificaciones',
  str0004: 'Mis Ventas',
  str0005: 'Mis Presupuestos',
  str0006: 'Mis pedidos',
  str0007: 'Mis clientes',
  str0008: 'Ventas',
  str0009: 'Presupuestos',
  str0010: 'Clientes',
  str0011: 'Cliente',
  str0012: 'Prospects',
  str0013: 'Prospect',
  str0014: 'Notificaciones',
  str0015: 'Pedidos',
  str0016: 'Pedido',
  str0017: 'Pedido de venta',
  str0018: 'Lista de precio',
  str0019: 'Tipo de operación',
  str0020: 'Productos',
  str0021: 'Producto',
  str0022: 'Presupuesto',
  str0023: 'Títulos',
  str0024: 'Cards',
  str0025: 'Gráficos',
  str0026: 'Datos',
  str0027: 'entrega',
  str0028: 'Cargando',
  str0029: 'Ningún dato encontrado',
  str0030: 'Informe el Alias deseado',
  str0031: 'Visualizar',
  str0032: 'Mostrar más',
  str0033: 'Error al autenticar',
  str0034: 'Finalizar',
  str0035: 'Fecha',
  str0036: 'Anular filtro',
  str0037: 'Lista',
  str0038: 'Fecha inválida',
  str0039: 'Aplicar filtro',
  str0040: 'Filtro de notificaciones',
  str0041: 'Tipo de notificación',
  str0042: 'Estatus de la notificación',
  str0043: 'Estatus del movimiento',
  str0044: 'Mostrar todas las notificaciones',
  str0045: 'Error al cargar las notificaciones',
  str0046: 'Error al actualizar las notificaciones',
  str0047: 'Descripción',
  str0048: 'Home',
  str0049: 'Tipo de filtro',
  str0050: 'Fecha inicial',
  str0051: 'Fecha final',
  str0052: 'Hora de la búsqueda',
  str0053: 'Anual',
  str0054: 'Mensual',
  str0055: 'Indicadores de venta',
  str0056: 'Mostrando indicadores de',
  str0057: 'Ningún filtro seleccionado',
  str0058: 'Filtro de indicadores',
  str0059: 'Aplicar filtros',
  str0060: 'Descarga de indicadores',
  str0061: 'Detalles',
  str0062: 'Filtro avanzado',
  str0063: 'Error en la validación de usuario',
  str0064: 'Nuevo pedido',
  str0065: 'Nuevo presupuesto',
  str0066: 'Observación',
  str0067: 'El sistema siempre utilizará el primero y último día de los meses seleccionados',
  str0068: 'Seleccione el formato de comparación entre los indicadores',
  str0069: 'Informe una fecha inicial y final para aplicar el filtro (dd/mm/aaaa)',
  str0070: 'La fecha inicial no debe ser mayor que la fecha final.',
  str0071: 'La diferencia entre las fechas no debe ser superior a 12 meses.',
  str0072: 'La diferencia entre las fechas no debe ser superior a 12 años.',
  str0073: 'Busque por la razón social del cliente',
  str0074: 'Razón social',
  str0075: 'Busque por el nombre de fantasía del cliente',
  str0076: 'Nombre comercial',
  str0077: 'Busque por el RCPF/RCPJ del cliente',
  str0078: 'RCPF/RCPJ',
  str0079: 'Fecha de inclusion',
  str0080: 'Seleccione el estatus del cliente',
  str0081: 'Estatus del cliente',
  str0082: 'dd/mm/aaaa',
  str0083: 'Estatus',
  str0084: 'Detalles del cliente',
  str0085: 'Cliente no encontrado',
  str0086: 'Se encontró más de un cliente con el mismo código',
  str0087: 'Contacte al equipo de TI',
  str0088: 'Dirección',
  str0089: 'CP',
  str0090: 'País',
  str0091: 'Est/Prov/Reg',
  str0092: 'Ciudad',
  str0093: 'Número',
  str0094: 'Complemento',
  str0095: 'Contactos',
  str0096: 'Tipo',
  str0097: 'Teléfono',
  str0098: 'No existen contactos grabados para este cliente',
  str0099: 'No se pudieron obtener los contactos del cliente porque este no tiene RCPF/RCPJ vinculado',
  str0100: 'Comercial',
  str0101: 'Teléfono comercial',
  str0102: 'Residencial',
  str0103: 'Fax comercial',
  str0104: 'Fax residencial',
  str0105: 'Celular',
  str0106: 'No identificado',
  str0107: 'Datos de registro',
  str0108: 'Inscripcion estatal',
  str0109: 'Inscripción Municipal',
  str0110: 'Código',
  str0111: 'Límite de crédito',
  str0112: 'Crédito utilizado',
  str0113: 'Total crédito',
  str0114: 'Riesgo de Crédito',
  str0115: 'Basado en el historial financiero del cliente',
  str0116: 'Insolvencia',
  str0117: 'De probabilidad de insolvencia',
  str0118: 'Conéctese a Internet para tener acceso.',
  str0119: 'Ver detalles',
  str0120: 'Título',
  str0121: 'Cantidad de títulos pendientes',
  str0122: 'Espere',
  str0123: 'Confirmar',
  str0124: 'Modificar usuario',
  str0125: '¡ATENCIÓN! Si confirma la operación, ¿todas las sincronizaciones pendientes se ignorarán?',
  str0126: 'Busque un pedido con su código, cliente o fecha de emisión',
  str0127: 'Filtro de pedidos',
  str0128: 'Formato de comparación',
  str0129: 'Seleccione el período de comparación',
  str0130: 'Visualizada',
  str0131: 'Busque por el número del título, fecha de vencimiento, fecha de emisión.',
  str0132: 'Pedido liberado para facturación',
  str0133: 'Pedido facturado',
  str0134: 'Cliente concretado',
  str0135: 'Pedido revertido',
  str0136: 'Pedido bloqueado por crédito',
  str0137: 'Pedido bloqueado por stock',
  str0138: 'Hora',
  str0139: 'Movimiento de pedido',
  str0140: 'Movimiento de cliente',
  str0141: 'Esperando visualización',
  str0142: 'Activado',
  str0143: 'Desactivado',
  str0144: 'Última compra',
  str0145: 'Tienda',
  str0146: 'Procesando....',
  str0147: 'Título Atrasado',
  str0148: 'Sin asuntos pendientes',
  str0149: 'Asuntos pendientes financieros',
  str0150: 'Visualizar detalles',
  str0151: 'Financiero',
  str0152: 'Filtro de clientes',
  str0153: 'Código del cliente',
  str0154: 'RCPJ',
  str0155: 'RCPF',
  str0156: 'Nombre completo',
  str0157: 'Nombre',
  str0158: 'Verif. Final',
  str0159: 'Productor rural',
  str0160: 'Revendedor',
  str0161: 'Solidario',
  str0162: 'Exportación',
  str0163: 'Tipo de cliente',
  str0164: 'Datos del contacto',
  str0165: 'E-mail',
  str0166: 'Teléfonos',
  str0167: 'Muy bajo',
  str0168: 'Abajo',
  str0169: 'Medio',
  str0170: 'Alto',
  str0171: 'Muy alto',
  str0172: 'Crédito disponible',
  str0173: 'Pendiente',
  str0174: 'Atrasado',
  str0175: 'Pagado',
  str0176: 'Número del título',
  str0177: 'Valor',
  str0178: 'Vencimiento',
  str0179: 'Prefijo',
  str0180: 'Sucursal',
  str0181: 'Cuota',
  str0182: 'Emisión',
  str0183: 'Val. Liquidado',
  str0184: 'Saldo pendiente',
  str0185: 'Bj. Parcial',
  str0186: 'ATENCIÓN: EL TOTAL DEL PEDIDO PRESENTADO COMO "Valor", SE REFIERE AL VALOR BRUTO DE LOS ÍTEMS.',
  str0187: 'Código del pedido',
  str0188: 'B. Regla',
  str0189: 'B. Fondo',
  str0190: 'Finalizado',
  str0191: 'Liberado',
  str0192: 'Bloqueado por Regla',
  str0193: 'Bloqueado por Concepto',
  str0194: 'Pedido no sincronizado',
  str0195: 'Algunas informaciones del pedido pueden modificar después de la sincronización. ¿Desea continuar generando el PDF?',
  str0196: 'Continuar',
  str0197: 'No sincronizado',
  str0198: 'Error',
  str0199: 'Online',
  str0200: 'Informe la fecha completa.',
  str0201: 'Estatus del pedido',
  str0202: 'Busque por el nombre o código del cliente',
  str0203: 'Busque por el nombre o código del Cliente/Prospect',
  str0204: 'Busque por el código o descripción del producto',
  str0205: 'Trabajando Off Line',
  str0206: 'Trabajar Off Line',
  str0207: 'Volver a mis pedidos',
  str0208: 'Editar pedido',
  str0209: 'Borrar pedido',
  str0210: 'Detalles del pedido',
  str0211: 'Generar PDF',
  str0212: 'Descarga del resumen',
  str0213: 'Pedido no encontrado',
  str0214: 'Se encontró más de un cliente con el mismo código',
  str0215: 'Vendedor',
  str0216: 'Liberación por ítem',
  str0217: 'Liberación por pedido',
  str0218: 'A cuenta de terceros',
  str0219: 'Por cuenta remitente',
  str0220: 'Por cuenta destinatario',
  str0221: 'Sin flete',
  str0222: 'CIF',
  str0223: 'FOB',
  str0224: 'No especificado',
  str0225: 'Entrega y pago',
  str0226: 'Tipo de Liberacion',
  str0227: 'Tipo de flete',
  str0228: 'Empresa de transportes',
  str0229: 'Dirección de entrega',
  str0230: 'Condición de pago',
  str0231: 'Informaciones del cliente',
  str0232: 'Dirección de la facturación',
  str0233: 'Total del pedido',
  str0234: 'Subtotal',
  str0235: 'Impuestos',
  str0236: 'Flete',
  str0237: 'Seguro',
  str0238: 'Gastos',
  str0239: 'Descuentos',
  str0240: 'Descuento',
  str0241: 'No',
  str0242: 'Ítem',
  str0243: 'Ítems',
  str0244: 'Cantidad',
  str0245: 'Precio unitario',
  str0246: 'Total',
  str0247: 'Informaciones Generales',
  str0248: 'Busque por el código o descripción del producto',
  str0249: 'Iniciar pedido',
  str0250: 'Iniciar presupuesto',
  str0251: 'Anular',
  str0252: 'Ítems del pedido',
  str0253: 'Ítems del presupuesto',
  str0254: 'Datos generales',
  str0255: 'Ver detalles del cliente',
  str0256: 'Subtotal del pedido',
  str0257: 'Cantidad de ítems',
  str0258: 'Anular pedido',
  str0259: 'Anular modificación',
  str0260: '¿Está seguro que desea anular la modificación del pedido?',
  str0261: '¿Está seguro que desea anular el nuevo pedido?',
  str0262: 'Próximo paso',
  str0263: 'Cant. Ítems',
  str0264: 'Visibilidad de ítems',
  str0265: 'Seleccione una lista de precio para visualizar los ítems y sus detalles.',
  str0266: 'Comentarios',
  str0267: 'Límite de crédito disponible',
  str0268: 'Descuento acumulativo de los ítems',
  str0269: 'Seleccione una lista de precio',
  str0270: 'Todos los ítems de la lista',
  str0271: 'Solamente ítems del pedido',
  str0272: 'Seleccione el modo de pago',
  str0273: 'Seleccione la transportadora',
  str0274: 'Seleccione el tipo de flete',
  str0275: 'Informe el valor del seguro',
  str0276: 'Informe el valor de los gastos',
  str0277: 'Informaciones generales del pedido',
  str0278: 'Informaciones de entrega',
  str0279: 'Informe el valor del flete',
  str0280: 'Seleccione el tipo de liberación',
  str0281: 'Tipo del pedido',
  str0282: 'Moneda',
  str0283: 'Parcial',
  str0284: 'En cartera',
  str0285: 'Porcentaje',
  str0286: 'Valor en moneda',
  str0287: 'Descuento en producto',
  str0288: 'Precio de lista',
  str0289: 'Precio unitario informado',
  str0290: 'Precio total del producto',
  str0291: 'Descuento en',
  str0292: 'Descuento porcentaje',
  str0293: 'Solamente números',
  str0294: 'Valor del descuento',
  str0295: 'Valor con descuento',
  str0296: 'Margen con descuento',
  str0297: 'Anular descuento',
  str0298: 'Aplicar descuento',
  str0299: 'No se pudo generar el archivo. Intente nuevamente.',
  str0300: 'Busque un producto por su código o descripción',
  str0301: 'Comentarios del pedido',
  str0302: 'El cliente no podrá ver los comentarios incluidos.',
  str0303: 'Valor total',
  str0304: 'Agregar descuento',
  str0305: 'Buscar productos',
  str0306: 'Productos seleccionados',
  str0307: 'Mostrando',
  str0308: 'de',
  str0309: 'encontrado',
  str0310: 'encontrados',
  str0311: 'Agregue comentarios del pedido. Ejemplo: Entregar en el período de la tarde, solicitar firma de la gerente de operación...',
  str0312: 'Listas de precios inactivas',
  str0313: 'Lista de precio fuera de vigencia.',
  str0314: 'Precios del producto fuera de vigencia',
  str0315: 'Producto seleccionado',
  str0316: 'Ningún producto seleccionado',
  str0317: 'Resumen del pedido',
  str0318: 'Error al devolver la condición de pago',
  str0319: 'Pendiente de sincronización',
  str0320: 'Prc. Unit.',
  str0321: 'Prc. Lista',
  str0322: 'Prc. Total',
  str0323: 'Cant. Entr.',
  str0324: 'El valor de los impuestos se calculará solamente después de sincronizar el pedido.',
  str0325: 'Condición de pago no válida para esta lista de precios',
  str0326: 'Agregar',
  str0327: '+ Informaciones',
  str0328: 'Seleccione el tipo de operación',
  str0329: 'Informe un cliente o prospect para iniciar el presupuesto',
  str0330: 'Informe un cliente para iniciar el pedido',
  str0331: 'Modificar pedido',
  str0332: 'Falla al incluir Pedido de venta',
  str0333: 'Pedido enviado para sincronización.',
  str0334: 'Error al enviar el JSON',
  str0335: 'Error al enviar el pedido para sincronización',
  str0336: 'Pedido concretado',
  str0337: 'Falla al integrar pedido',
  str0338: 'Mostrar detalles del pedido',
  str0339: 'Falla al borrar Pedido de Venta',
  str0340: 'Confirme el borrado',
  str0341: '¿Desea realmente borrar este pedido?',
  str0342: 'Estatus no válido',
  str0343: 'No se permite borrar un pedido de venta con estatusz Liberado, Finalizado o No sincronizado.',
  str0344: 'Pedido incluido',
  str0345: 'Pedido modificado',
  str0346: 'Pedido borrado',
  str0347: 'Salir',
  str0348: '¿Está seguro que desea salir?',
  str0349: 'Pueden existir pedidos pendientes de sincronización, al salir estos se anularán.',
  str0350: 'El valor total del pedido pode variar de acuerdo con su conexión de Internet, ya que los impuestos se calculan solamente si estuviera On Line.',
  str0351: 'Falla al calcular impuestos',
  str0352: 'Intente nuevamente más tarde.',
  str0353: 'Calculando totales',
  str0354: 'Falla al grabar el log de acceso',
  str0355: 'Su sesión expiró',
  str0356: 'Es necesario efectuar el acceso nuevamente para sincronizar sus cambios. ¿\nDesea realizar el acceso ahora? En caso contrario el sistema estará en modo Off Line.',
  str0357: 'Falla al devolver los tipos de operación',
  str0358: 'Volver al Mis Presupuestos',
  str0359: 'Detalles del presupuesto',
  str0360: 'Falla al cargar el presupuesto',
  str0361: 'Falla al cargar el cliente',
  str0362: 'Más información',
  str0363: 'Informaciones del prospect',
  str0364: 'Código del prospect',
  str0365: 'Falla al cargar prospect',
  str0366: 'Busque un presupuesto por el código, Código del Cliente/Prospect o fecha de emisión',
  str0367: 'Seleccione el estatus del pedido',
  str0368: 'Pendiente',
  str0369: 'Dado de baja',
  str0370: 'Anulado',
  str0371: 'No presupuestado',
  str0372: 'Bloqueado',
  str0373: 'Fch. Emisión',
  str0374: 'Falla al devolver búsqueda de productos.',
  str0375: 'Estatus del presupuesto',
  str0376: 'Filtro de presupuestos',
  str0377: 'Cliente o Prospect',
  str0378: 'Código del presupuesto',
  str0379: 'Busque un cliente por su Código, Nombre o RCPJ',
  str0380: 'Busque un prospect por su Código, Nombre o RCPJ',
  str0381: 'Presupuesto incluido',
  str0382: 'Presupuesto modificado',
  str0383: 'Presupuesto borrado',
  str0384: 'Busque por el código, nombre fantasía o RCPJ/RCPF del cliente.',
  str0385: 'Seleccione el tipo de notificación',
  str0386: 'Seleccione el estatus de la notificación',
  str0387: 'Seleccione el estatus del movimiento',
  str0388: 'Seleccione el estatus del presupuesto',
  str0389: 'Busque una notificación por su título o descripción',
  str0390: 'Error al cargar presupuestos',
  str0391: 'Error al devolver las notificaciones',
  str0392: 'Error al devolver los clientes',
  str0393: 'Error al devolver los pedidos',
  str0394: 'Error al devolver los productos',
  str0395: 'Error al devolver los títulos',
  str0396: 'Error al devolver vendedores',
  str0397: 'Falla al actualizar el precio unitario',
  str0398: 'Falla al cargar ítem de la lista de precio',
  str0399: 'No se pudo encontrar el producto informado',
  str0400: 'Cargando datos de entrega...',
  str0401: 'Cargando datos del pedido...',
  str0402: 'Cargando Cards y Gráficos',
  str0403: 'Error al consultar insolvencia',
  str0404: 'Seleccione el estatus del presupuesto',
  str0405: 'Editar presupuesto',
  str0406: 'Borrar presupuesto',
  str0407: 'Nuevo presupuesto',
  str0408: 'Iniciar presupuesto',
  str0409: 'Ítems del presupuesto',
  str0410: 'Grabar',
  str0411: 'Subtotal del presupuesto',
  str0412: 'Total del presupuesto',
  str0413: 'Anular presupuesto',
  str0414: '¿Está seguro que desea anular la modificación del presupuesto?',
  str0415: '¿Está seguro que desea anular el nuevo presupuesto?',
  str0416: 'Solamente ítems del presupuesto',
  str0417: 'Informaciones generales del presupuesto',
  str0418: 'Tipo de presupuesto',
  str0419: 'Resumen del presupuesto',
  str0420: 'Modificar presupuesto',
  str0421: 'Falla al incluir presupuesto.',
  str0422: 'Presupuesto enviado para sincronización.',
  str0423: 'Presupuesto concretado',
  str0424: 'Falla al integrar presupuesto',
  str0425: 'Mostrar detalles del presupuesto',
  str0426: '¿Desea realmente borrar este presupuesto?',
  str0427: 'No se permite eliminar un presupuesto con el estatus Dado de Baja, No Sincronizado o que tenga una propuesta comercial vinculada.',
  str0428: 'Cargando datos del presupuesto...',
  str0429: 'Presupuesto',
  str0430: 'Detalles del presupuesto',
  str0431: 'Falla al cargar el presupuesto',
  str0432: 'Mis Presupuestos',
  str0433: 'Presupuestos',
  str0434: 'Busque un presupuesto por el código, Código del Cliente/Prospect o fecha de emisión',
  str0435: 'Cargando presupuestos',
  str0436: 'Error al cargar presupuestos',
  str0437: 'Pendiente',
  str0438: 'Dado de baja',
  str0439: 'Anulado',
  str0440: 'No presupuestado',
  str0441: 'Bloqueado',
  str0442: 'Número',
  str0443: 'Fch. Emisión',
  str0444: 'Falla al devolver búsqueda de productos.',
  str0445: 'Estatus del presupuesto',
  str0446: 'Filtro de presupuestos',
  str0447: 'Cliente o Prospect',
  str0448: 'Código del presupuesto',
  str0449: 'Busque un prospect por su Código, Nombre o RCPJ',
  str0450: 'Presupuesto incluido',
  str0451: 'Presupuesto modificado',
  str0452: 'Presupuesto borrado',
  str0453: 'Movimiento de presupuesto',
  str0454: 'Busque un cliente por su Código, Nombre o RCPJ',
  str0455: 'Volver al Mis Presupuestos',
  str0456: 'Mostrar detalles del presupuesto',
  str0457: 'Presupuesto no sincronizado',
  str0458: 'Algunas informaciones del presupuesto se pueden modificar después de la sincronización. ¿Desea continuar generando el PDF?',
  str0459: 'No se debe borrar el presupuesto, porque existe una propuesta comercial vinculada.',
  str0460: 'Campos personalizados',
  str0461: 'Falla al borrar presupuesto',
  str0462: 'Error al devolver los presupuestos',
  str0463: 'Valor no válido',
  str0464: 'Grabar pedido',
  str0465: 'El valor total del presupuesto pode variar de acuerdo con su conexión de Internet, pues los impuestos se calculan solamente si estuviera online.',
  str0466: 'Error en el envío del presupuesto para sincronización',
  str0467: 'Datos financieros',
  str0468: 'Sincronizando',
  str0469: 'Facturación (Valor)',
  str0470: 'No se aplica',
  str0471: 'Presencial',
  str0472: 'Operación no presencial, por Internet',
  str0473: 'No presencial, Teleatención',
  str0474: 'Presencial, Fuera del Estab.',
  str0475: 'No presencial, Otros',
  str0476: 'Código del intermediador',
  str0477: 'Presencia del comprador',
  str0478: 'Intermediador financiero',
  str0479: 'Falla al obtener intermediadores financieros',
  str0480: 'Seleccione el intermediador financiero',
  str0481: 'Seleccione el indicador de presencia',
  str0482: 'Sincronización interrumpida, haga clic en la «X» del menú anterior para reiniciar',
  str0483: 'Error en la sincronización.',
  str0484: 'No fue posible realizar la carga inicial de los datos. Intente nuevamente haciendo clic aquí.',
  str0485: 'Volver',
  str0486: 'Calculando...',
  str0487: 'Incluya su usuario',
  str0488: 'Incluya su contraseña',
  str0489: 'Falla al obtener lista de campos',
  str0490: 'Este contacto no tiene teléfonos.',
  str0491: 'Este cliente no tiene límite de crédito informado.',
  str0492: 'Este campo no acepta caracteres especiales.',
  str0493: 'Pedido incluido con éxito.',
  str0494: 'Pedido modificado con éxito.',
  str0495: 'Falla al modificar Pedido de venta.',
  str0496: 'Pedido borrado con éxito.',
  str0497: 'Error al calcular total:',
  str0498: 'contiene',
  str0499: 'Borrando pedido...',
  str0500: 'No se encontraron los schemas necesarios para utilización del TGV. Verifique si la función SETUPTGV se ejecutó de acuerdo con la documentación: <a href=»https://tdn.totvs.com/pages/releaseview.action?pageId=579468339#TOTVSGest%C3%A3odeVentas:GuiadeReferencia-CONFIG_PILOTO» target=»_blank»> TGV - Guía de referencia </a>',
  str0501: 'Cantidad de productos',
  str0502: 'Cant. Productos',
  str0503: 'Acceso negado',
  str0504: '¡Usuario no tiene vínculo con un Vendedor!',
  str0505: 'Usuario no tiene acceso a datos sensibles o personales',
  str0506: 'Error en el Schema',
  str0507: 'Falla al devolver Pedido de venta',
  str0508: 'Falla al devolver los schemas. Verifique las tablas A1V y A1W.',
  str0509: 'Cargando ítems del pedido...',
  str0510: 'Normal',
  str0511: 'Complemento de Precio/Cantidad',
  str0512: 'Complemento de ICMS',
  str0513: 'Complemento de IPI',
  str0514: 'Devolución de compras',
  str0515: 'Utiliza proveedor',
  str0516: 'Falla al obtener ítem del pedido',
  str0517: 'Falla al devolver opciones para el Tipo de pedido',
  str0518: 'Falla al devolver país',
  str0519: 'Digite el código del grupo o realice su búsqueda haciendo clic en la lupa',
  str0520: 'Digite el código de la sucursal o realice su búsqueda haciendo clic en la lupa',
  str0521: 'Grupo',
  str0522: 'Cambiar de sucursal',
  str0523: 'ATENCIÓN: la sucursal seleccionada es la misma que la actual. Seleccione una sucursal diferente.',
  str0524: 'Entrar',
  str0525: 'ATENCIÓN',
  str0526: 'Su sesión expiró. Para continuar, realice la conexión nuevamente.',
  str0527: 'Consultando títulos',
  str0528: 'Portal de ventas',
  str0529: 'Cargando información del cliente...',
  str0530: 'Falla al consultar vendedor',
  str0531: 'Falla al obtener informaciones financieras',
  str0532: 'Usted puede actualizar su versión descargando el paquete de la expedición continua haciendo clic en <a href="https://tdn.totvs.com/pages/releaseview.action?pageId=521997859" target="_blank">AQUI</a>.',
  str0533: 'Versión del PGV desactualizada',
  str0534: 'Nueva versión disponible. ¿Desea recargar la página?',
  str0535: 'Falla al intentar filtrar Presupuestos de ventas',
  str0536: 'Mensaje',
  str0537: 'Consultando nombre del Prospect',
  str0538: 'Consultando nombre del Cliente',
  str0539: 'Falla al consultar nombre del Prospect',
  str0540: 'Falla al consultar nombre del Cliente',
  str0541: 'No fue posible registrar el vendedor',
  str0542: 'Falla al cargar ítems del presupuesto',
  str0543: 'Presupuesto borrado con éxito.',
  str0544: 'Borrando presupuesto...',
  str0545: 'Sí',
  str0546: 'Tipo de prospect',
  str0547: 'Presupuesto incluido con éxito.',
  str0548: 'Presupuesto modificado con éxito.',
  str0549: 'No se permite modificar un presupuesto con el estatus Dado de baja, Anulado, No sincronizado o que tenga una Propuesta comercial vinculada.',
  str0550: 'Falla al modificar presupuesto.',
  str0551: 'Mensaje de la factura',
  str0552: 'Agregue comentarios que sean importantes sobre este pedido de venta.',
  str0553: 'El mensaje definido se imprimirá en la factura.',
  str0554: 'Agregue un mensaje que se utilizará en la factura. Ejemplo: Entregar en el período de la tarde.',
  str0555: 'Sincronizar datos',
  str0556: 'Sincronización completada',
  str0557: 'Sincronizando datos, por favor espere...',
  str0558: 'Falla al devolver permisos de acceso del usuario',
  str0559: 'Usted no tiene acceso a esta página',
  str0560: 'Entre en contacto con el administrador del sistema.',
  str0561: 'Vuelva al inicio',
  str0562: 'Filtrar por lista de precios',
  str0563: 'Falla al consultar el parámetro MV_PGVCSLD',
  str0564: 'Caramba, algo salió mal',
  str0565: 'Consultar stock',
  str0566: 'Almacén',
  str0567: 'Saldo actual',
  str0568: 'Cant. Pedido de venta',
  str0569: 'Cant. Reservada',
  str0570: 'Cant. Prevista entrada',
  str0571: 'Falla al consultar Saldo del producto',
  str0572: 'Otras informaciones',
  str0573: 'Pedido del cliente',
  str0574: 'Número de pedido del cliente',
  str0575: 'Falla al consultar Schema',
  str0576: 'Mis configuraciones Off Line',
  str0577: 'Configuraciones Off Line',
  str0578: 'Editar',
  str0579: 'Busque un Schema por su Código o Descripción',
  str0580: 'Falla al intentar filtrar Schemas',
  str0581: 'Volver a mis configuraciones',
  str0582: 'Editar mis configuraciones',
  str0583: 'Avanzar',
  str0584: 'Editar configuraciones de los',
  str0585: 'Filtro rápido',
  str0586: 'Seleccionar registros',
  str0587: 'No se agregó ningún ítem al Pedido de venta',
  str0588: 'No se agregó ningún ítem al Presupuesto de venta',
  str0589: 'Clientes que compraron en:',
  str0590: 'Habilitado',
  str0591: 'Desactivar',
  str0592: 'Igual',
  str0593: 'Tiene la expresión',
  str0594: 'Tipo de búsqueda',
  str0595: 'Seleccione el tipo de búsqueda deseado',
  str0596: 'Últimos tres meses',
  str0597: 'Seleccione solamente los productos más vendidos por el vendedor en los últimos tres meses.',
  str0598: 'Saldo en stock',
  str0599: 'Informe el código de los productos separando por coma',
  str0600: 'Informe la descripción de los productos separando por coma',
  str0601: 'Informe el tipo de los productos separando por coma Ej: PA, MP',
  str0602: 'Informe el código de la lista de precios separando por coma',
  str0603: 'Seleccione solamente los productos que tengan saldo en stock.',
  str0604: 'Descripción del Producto 1, Descripción del Producto 2',
  str0605: '000001,000002,000003,000004',
  str0606: 'Tabla 1, Tabla 2',
  str0607: 'Último mes',
  str0608: 'Seleccione solamente Clientes que compraron en el último mes.',
  str0609: 'Seleccione solamente Clientes que compraron en los últimos tres meses.',
  str0610: 'Nuevos Clientes',
  str0611: 'Seleccione clientes registrados en el último mes.',
  str0612: 'No compraron en el último mes',
  str0613: 'Seleccione clientes que no compraron el último mes.',
  str0614: 'Informe el código de los clientes separando por coma.',
  str0615: 'Nombre Fantasía / Razón Social',
  str0616: 'Informe el Nombre Fantasía o Razón Social separando por coma.',
  str0617: 'João da Silva,Maria Lima,José de Souza',
  str0618: 'Informe el RCPF o RCPJ de los clientes separando por coma.',
  str0619: '00.000.000/0000-00',
  str0620: 'PA, MP',
  str0621: 'Vacío',
  str0622: 'Esta página no está disponible para utilizar Off Line',
  str0623: 'Off Line',
  str0624: 'seleccionados',
  str0625: 'Filtrar registros por:',
  str0626: 'No hay datos seleccionados',
  str0627: 'Falla al consultar el Límite de Crédito, por favor actualice el servidor backend con el último paquete de expedición continua de la facturación.',
  str0628: 'Marcar/Desmarcar',
  str0629: 'Seleccione todos',
  str0630: 'Nº Externo',
  str0631: 'Código',
  str0632: 'Activo',
  str0633: 'Almacén',
  str0634: 'Unidad de medida',
  str0635: 'Filtro registrado con éxito.',
  str0636: 'Filtro eliminado con éxito.',
  str0637: 'Falla al registrar filtro.',
  str0638: 'Falla al eliminar filtro.',
  str0639: '¿ Desea realizar la carga de datos ?',
  str0640: 'Realizar la carga de los datos',
  str0641: '¡Epa! El límite de',
  str0642: 'ítems fue alcanzado',
  str0643: 'Ítem facturado total o parcialmente, para borrarlo es necesario borrar la factura correspondiente.',
  str0644: 'Esta página estará disponible en breve',
  str0645: 'Estamos sincronizando los datos, por favor espere...',
  str0646: 'Alias no encontrado',
  str0647: 'Origen',
  str0648: 'Usuario no autenticado - Verifique si el usuario se encuentra bloqueado o si este se registró en el Protheus.',
  str0649: 'Su usuario no tiene vínculo con un vendedor. Para ajustar esto se debe hacer la atribución de acuerdo con la documentación <a href="https://tdn.totvs.com/pages/viewpage.action?pageId=649301318" target="_blank"> haciendo clic aquí </a>',
  str0650: '¡Epa! No se pudo acceder a su usuario.',
  str0651: 'Falla al consultar transportadoras',
  str0652: 'Fch.Registro',
  str0653: 'Límite de conexiones excedidos',
  str0654: 'Página no encontrada.',
  str0655: 'Disculpe, la página que está buscando no existe.',
  str0656: 'Seleccione solamente Prospects que tienen presupuestos pendientes en el último mes.',
  str0657: 'Seleccione solamente Prospects que tienen presupuestos pendientes en los últimos tres meses.',
  str0658: 'Seleccione Prospects registrados en el último mes.',
  str0659: 'Seleccione Prospects sin presupuestos de ventas en los últimos tres meses.',
  str0660: 'Informe el código de los Prospects separando con coma.',
  str0661: 'Informe el RCPF o RCPJ de los Prospects separando con coma.',
  str0662: 'Nuevos Prospect',
  str0663: 'No compraron en los últimos tres meses',
  str0664: 'No se pudieron actualizar los datos financieros del cliente',
  str0665: 'Nuevo cliente',
  str0666: 'Iniciar registro',
  str0667: 'Seleccione un cliente para iniciar el registro',
  str0668: 'Persona tipo',
  str0669: '¿Agregar nueva tienda?',
  str0670: 'Persona física',
  str0671: 'Persona jurídica',
  str0672: 'Falla al consultar Tipo de persona del cliente',
  str0673: 'Seleccione las siguientes preferencias para el registro de un nuevo cliente.',
  str0674: 'No fue posible obtener el Tipo de operación estándar',
  str0675: 'No fue posible obtener los datos del parámetro',
  str0676: 'Epa, su empresa y sucursal no se encontraron en el TOTVS Mingle',
  str0677: 'Empresa/Sucursal no encontrada',
  str0678: 'Entre en contacto con el soporte de TOTVS Mingle para corregir el registro del Alias',
  str0679: 'Documento no válido',
  str0680: 'Digite la razón social o nombre completo',
  str0681: 'Digite el nombre o nombre fantasía',
  str0682: 'Digite la inscripción estatal',
  str0683: 'Digite la inscripción municipal',
  str0684: 'Seleccione el tipo',
  str0685: 'Tipo',
  str0686: 'Cargando opciones...',
  str0687: 'Digite el código',
  str0688: 'Sugerimos un código de identificación, pero puede modificarlo.',
  str0689: 'Digite el complemento de la dirección',
  str0690: 'Tipo de persona',
  str0691: 'Seleccione el tipo de persona',
  str0692: 'Informe solamente números',
  str0693: 'Seleccione el Estado/Prov/Reg',
  str0694: 'Seleccione la ciudad/municipio',
  str0695: 'Digite la dirección',
  str0696: 'Barrio',
  str0697: 'Digite el barrio',
  str0698: 'Nombre del contacto',
  str0699: 'Digite el nombre del contacto',
  str0700: 'Digite el email del contacto',
  str0701: 'Informe un e-mail válido.',
  str0702: 'Solamente números',
  str0703: 'Documento',
  str0704: 'Archivo de clientes',
  str0705: 'Identificación',
  str0706: 'Versión Core',
  str0707: 'Campos personalizados',
  str0708: 'No hay datos por mostrarse',
  str0709: 'Borrar',
  str0710: 'Editar Cliente',
  str0711: 'Cliente incluido con éxito.',
  str0712: 'Cliente modificado con éxito.',
  str0713: 'Cliente eliminado con éxito.',
  str0714: 'Falla al incluir cliente.',
  str0715: 'Falla al modificar cliente.',
  str0716: 'Falla al eliminar cliente.',
  str0717: '¿Desea realmente eliminar este cliente?',
  str0718: 'La clave Security está inhabilitada.',
  str0719: 'La versión de la Lib no está compatible con el PGV. Actualice la Lib del Protheus.',
  str0720: '¡Atención código y tienda ya registrados!',
  str0721: 'No fue posible verificar la clave security. Actualice la versión del backend, realice un logout y un login.',
  str0722: 'Mis Prospects',
  str0723: 'Busque por el código, nombre fantasía o RCPJ/RCPF del Prospect',
  str0724: 'Clasificado',
  str0725: 'Desarrollo',
  str0726: 'Gerente',
  str0727: 'StandBy',
  str0728: 'Descalificado',
  str0729: 'Falla al cargar Prospects',
  str0730: 'Estatus actual',
  str0731: 'Ops... la condición del pago seleccionado automáticamente',
  str0732: 'no se puede utilizar esta experiencia de venta. Contacte al especialista de TI de su empresa.',
  str0733: 'Epa... la lista de precio se seleccionó automáticamente',
  str0734: 'Cliente incluido',
  str0735: 'Cliente modificado',
  str0736: 'Cliente eliminado',
  str0737: 'Falla al integrar cliente',
  str0738: 'Busque por la razón social del prospect',
  str0739: 'Busque por el nombre fantasía del prospect',
  str0740: 'Busque por el RCPF/RCPJ del prospect',
  str0741: 'Seleccione el estatus del prospect',
  str0742: 'Seleccione la clasificación del prospect',
  str0743: 'Estatus del Prospect',
  str0744: 'Clasificación del Prospect',
  str0745: 'Filtro de los Prospect',
  str0746: 'Digite la ciudad/municipio',
  str0747: 'Falla al cargar el inicializador de los campos del formulario',
  str0748: 'Nuevo Prospect',
  str0749: 'Editar Prospect',
  str0750: 'Registro de Prospects',
  str0751: '¿Desea realmente eliminar este Prospect?',
  str0752: 'Prospect incluido con éxito.',
  str0753: 'Prospect modificado con éxito.',
  str0754: 'Prospect eliminado con éxito.',
  str0755: 'Falla al eliminar Prospect.',
  str0756: 'Falla al integrar Prospect',
  str0757: 'Actualización del enlace de acceso',
  str0758: 'Para una mejor experiencia en el Portal Gestión de Ventas, estamos actualizando el enlace de acceso a una cuenta Totvs en la AWS. De este modo, necesitamos que acceda hasta el 07/12, por el nuevo enlace. Si está accediendo de un tablet o celular, es necesario crear un nuevo atajo en su área de trabajo.',
  str0759: 'Detalles del Prospect',
  str0760: 'DDN',
  str0761: 'Est/Prov/Reg',
  str0762: 'HAGA CLIC AQUÍ',
  str0763: 'Seleccione las siguientes preferencias para registrar un nuevo cliente.',
  str0764: 'Mis Contactos',
  str0765: 'Búsqueda por código, nombre o CPF/CNPJ',
  str0766: '¿Realmente desea eliminar este contacto?',
  str0767: 'Contacto eliminado exitosamente',
  str0768: 'Falla al cargar Contactos',
  str0769: 'Falla al eliminar Contacto',
  str0770: 'Registro de contactos',
  str0771: 'DDI',
  str0772: 'Modificar contacto',
  str0773: 'Nuevo contacto',
  str0774: 'Contacto modificado con éxito.',
  str0775: 'Contacto incluido con éxito.',
  str0776: 'Falla al integrar Contacto',
  str0777: '¿Desea realmente borrar este Contacto ?',
  str0778: 'Contacto borrado con éxito.',
  str0779: 'Falla al borrar contacto.',
  str0780: 'Comercial',
  str0781: 'Residencial',
  str0782: 'Fax comercial',
  str0783: 'Fax residencial',
  str0784: 'Celular',
  str0785: 'Detalles del contacto',
  str0786: 'Datos de la dirección y teléfono',
  str0787: 'Total de pedidos de ventas',
  str0788: 'Cantidad del pedidos',
  str0789: 'Última actualización el',
  str0790: 'Total de pedidos de ventas pendientes',
  str0791: 'Total de pedidos de ventas bloqueados',
  str0792: 'Total de pedidos de ventas finalizados',
  str0793: 'Mis metas de ventas',
  str0794: 'Mis metas',
  str0795: 'Metas de ventas',
  str0796: 'Cantidad liberada',
  str0797: 'Factura',
  str0798: 'Serie',
  str0799: 'Código del cliente',
  str0800: 'Error al buscar lista de pedidos',
  str0801: 'Vincular contactos',
  str0802: 'Ningún Pedido Encontrado:',
  str0803: 'Error al buscar la meta de ventas del vendedor:',
  str0804: 'Valor bruto:',
  str0805: 'Valor neto:',
  str0806: 'Valor devuelto:',
  str0807: 'Meta mensual',
  str0808: '¡Datos registrados con éxito !',
  str0809: 'Falla al registrar datos.',
  str0810: 'Fecha de entrega',
  str0811: 'Error al buscar los datos del gráfico de ventas de los últimos 7 días.',
  str0812: 'Productos más vendidos - Mensual',
  str0813: 'Facturación de los últimos 7 días',
  str0814: 'Vl. Bruto',
  str0815: 'Vl. Neto',
  str0816: 'Vl. Devuelto',
  str0817: 'Cant. de ventas',
  str0818: 'Valor contable',
  str0819: 'Valor de la mercadería',
  str0820: 'Total de impuestos embutidos',
  str0821: 'Total de impuestos sin incidencia',
  str0822: 'Valor total de impuestos',
  str0823: 'Base duplicada',
  str0824: 'Gastos adicionales',
  str0825: 'Impuesto',
  str0826: 'Base de cálculo',
  str0827: 'Alícuota',
  str0828: 'Código del producto',
  str0829: 'Valor ST',
  str0830: 'Valor CSLL',
  str0831: 'Valor unitario',
  str0832: 'Alícuota PIS',
  str0833: 'Alícuota IPI',
  str0834: 'Valor PIS',
  str0835: 'Valor PIS Cálculo',
  str0836: 'Valor PIS ST',
  str0837: 'Alícuota COFINS',
  str0838: 'Valor COFINS',
  str0839: 'Valor COFINS Cálculo',
  str0840: 'Alícuota ST',
  str0841: 'Alícuota CSLL',
  str0842: 'Valor ICMS',
  str0843: 'Valor IPI',
  str0844: 'TES',
  str0845: 'Planilla financiera',
  str0846: 'Totales',
  str0847: 'Facturas del pedido:',
  str0848: 'No fue posible cargar las facturas',
  str0849: 'Facturas',
  str0850: 'No existen facturas vinculadas a este pedido de ventas',
  str0851: 'Factura',
  str0852: 'Tipo de factura',
  str0853: 'Clave de la factura',
  str0854: 'Serie de la factura',
  str0855: 'Factura clave electrónica',
  str0856: 'Datos para acceso de la factura',
  str0857: 'No hay URL registrada para este municipio.',
  str0858: 'No fue posible consultar la factura',
  str0859: 'Acceda a la factura',
  str0860: 'Clave de acceso',
  str0861: 'Estimado cliente, usted será reorientado al sitio del municipio. Para descargar la Factura de servicio es necesario completar las informaciones solicitadas.',
  str0862: 'Personalizar PDF',
  str0863: 'Url de la imagen',
  str0864: 'Seleccione el tipo de Personalización',
  str0865: 'Tipo de PDF',
  str0866: 'Nuevo Pdf personalizado',
  str0867: 'Mis configuraciones de PDF',
  str0868: 'Editar PDF',
  str0869: 'Nuevo PDF',
  str0870: 'PDF modificado con éxito',
  str0871: 'PDF incluido con éxito',
  str0872: 'Falla al incluir PDF',
  str0873: 'Secciones',
  str0874: 'Campos',
  str0875: 'Código de la sección',
  str0876: 'Título de la sección',
  str0877: 'Descripción de la sección',
  str0878: 'Seleccione la sección',
  str0879: 'Seleccione los campos',
  str0880: 'Encabezado',
  str0881: 'Propiedad',
  str0882: 'Formato',
  str0883: 'Decimal',
  str0884: 'Separador de millares',
  str0885: 'Mover hacia arriba',
  str0886: 'Mover hacia abajo',
  str0887: 'Incluir campo',
  str0888: 'Modificar campo',
  str0889: 'Carácter',
  str0890: 'Numérico',
  str0891: 'Lógico',
  str0892: 'Confirma borrado de la sección',
  str0893: '¿Realmente desea borrar esta sección? Al borrar, también se borrarán los campos.',
  str0894: 'Confirme',
  str0895: 'Confirma borrado del campo',
  str0896: '¿Realmente desea borrar este campo?',
  str0897: 'Informe todos los datos obligatorios antes de confirmar la inclusión.',
  str0898: 'Hay campos obligatorios en las configuraciones del PDF que no se completaron.',
  str0899: 'Hay campos obligatorios en alguna de las secciones de la configuración del PDF que no se completaron.',
  str0900: 'Hay alguna sección de la configuración del PDF que no tiene campos informados.',
  str0901: 'No se informó ninguna sección de la configuración del PDF. Esto es necesario para la grabación de la configuración en la base de datos.',
  str0902: 'Falla al cargar las configuraciones de PDF',
  str0903: 'Confirma borrado de la configuración de PDF',
  str0904: '¿Realmente desea borrar esta configuración de PDF?',
  str0905: 'Busque por el código, título o descripción de la configuración de PDF.',
  str0906: 'Visualizar PDF',
  str0907: 'Selección de PDF',
  str0908: 'Seleccione el modelo de PDF',
  str0909: 'Modelo estándar',
  str0910: 'No es posible agregar más que una sección de ítems',
  str0911: 'Personalizado',
  str0912: 'No es posible incluir más de 7 campos en secciones del tipo Ítems',
  str0913: 'Mis Productos',
  str0914: 'Foto del producto',
  str0915: 'Realizar',
  str0916: 'Realización del presupuesto',
  str0917: '¿Desea continuar con la realización del presupuesto?',
  str0918: 'Anular',
  str0919: 'Anulación del presupuesto',
  str0920: '¿Desea continuar con la anulación del presupuesto?',
  str0921: 'Error al realizar el presupuesto.',
  str0922: 'Error al anular el presupuesto.',
  str0923: 'Mis Comisiones',
  str0924: 'Comisiones',
  str0925: 'La url de la imagen no es válida o está bloqueada por CORS. Entre en contacto con su área de TI o informe una url válida.',
  str0926: 'Consultar',
  str0927: 'Exportar xlsx',
  str0928: 'No fue posible cargar los datos del informe',
  str0929: 'Verifique si se completaron correctamente todos los campos antes de realizar la consulta',
  str0930: 'La fecha del campo "¿A Fecha ?" debe ser posterior a la fecha del campo "¿De Fecha ?" y el intervalo entre las dos no puede exceder 1 año.',
  str0931: 'Volver a mis comisiones',
  str0932: 'No se encontró ningún registro con los valores informados.',
  str0933: "Logotipo estándar",
  str0934: "Logotipo del PDF estándar actualizado con éxito",
  str0935: 'Actualice la versión del backend del PGV, según el siguiente enlace, después realice un Logout y un Login.',
  str0936: 'Contacto vinculado con éxito',
  str0937: 'Falla al incluir/modificar el contacto',
  str0938: 'En aprobación',
  str0939: 'Rechazado',
  str0940: "Control de crédito por"
};
